import * as React from 'react';
import { Formatters } from '../../codegen/Localize';
import { DataRoleSingleValue } from '../../ts/ServerApi/types/IDataRole';
import { boldClass } from '../styles/DefinitionSubspaceSharedStyles';

export const highlightSearch = (targetText: string, searchText: string): React.ReactNode => {
  if (searchText === '') { return targetText; }
  return targetText
    .split(RegExp('(' + searchText + ')', 'gi'))
    .map((fragment: string, index: number) => (
      <React.Fragment key={index}>
        {
          (fragment.toLowerCase() === searchText.toLowerCase()) ?
          <span className={boldClass}>{fragment}</span>: fragment
        }
      </React.Fragment>));
};

export const formatValue = (value: DataRoleSingleValue) => (
  value.stringValue !== undefined ? value.stringValue :
  value.timeValue !== undefined ? Formatters.formatMediumDateTimeWithoutSeconds(new Date(value.timeValue)) :
  value.numberValue !== undefined && value.numberValue % 1 === 0 ? Formatters.formatCount(value.numberValue) :
  value.numberValue !== undefined ? Formatters.formatFloat(value.numberValue) :
  value.boolValue !== undefined ? value.boolValue ? 'True' : 'False' :
  'Null'
);

export const compareValues = (a: DataRoleSingleValue, b: DataRoleSingleValue) => (
  a.stringValue !== undefined ? a.stringValue.localeCompare(b.stringValue) :
  a.timeValue !== undefined ? a.timeValue - b.timeValue :
  a.numberValue !== undefined ? a.numberValue - b.numberValue:
  a.boolValue !== undefined ? a && 1 : 0
);

export const matchesSearch = (value: DataRoleSingleValue, searchText: string): boolean  =>
  formatValue(value)
    .toLocaleLowerCase()
    .indexOf(searchText.toLocaleLowerCase()) > -1 ||
  value.valueSynonyms && value.valueSynonyms.some(synonym =>
    (synonym
    .toLocaleLowerCase()
    .indexOf(searchText.toLocaleLowerCase()) > -1));
